import React, { useState, useEffect } from 'react';
import { Outlet, Link } from "react-router-dom";
import classNames from 'classnames';

// Navigation pieces
import AppTopBar from './layout/AppTopbar';
import AppMenu from './layout/AppMenu';

const App = (props) => {
    const { menu, sectionCount, firstPage } = props
	const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarUserMenuActive, setTopbarUserMenuActive] = useState(false);
    const [topbarNotificationMenuActive, setTopbarNotificationMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
	const [menuMode, setMenuMode] = useState('static');
	const [menuActive, setMenuActive] = useState(false);

    let menuClick = false;
    let searchClick = false;
    let userMenuClick = false;
    let notificationMenuClick = false;
    let configClick = false;

	let routers = []

    useEffect(() => {
        if (staticMenuMobileActive) {
            blockBodyScroll();
        }
        else {
            unblockBodyScroll();
        }
    }, [staticMenuMobileActive]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!userMenuClick) {
            setTopbarUserMenuActive(false);
        }

        if (!notificationMenuClick) {
            setTopbarNotificationMenuActive(false);
        }

        if (!menuClick) {
           if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        searchClick = false;
        configClick = false;
        userMenuClick = false;
        notificationMenuClick = false;
        menuClick = false;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarUserMenuActive(false);
        setTopbarNotificationMenuActive(false);

       

        if (isDesktop()) {
            setStaticMenuDesktopInactive(prevStaticMenuDesktopInactive => !prevStaticMenuDesktopInactive);
        }
        else {
            setStaticMenuMobileActive(prevStaticMenuMobileActive => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onTopbarUserMenuButtonClick = (event) => {
        userMenuClick = true;
        setTopbarUserMenuActive(prevTopbarUserMenuActive => !prevTopbarUserMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarNotificationMenuButtonClick = (event) => {
        notificationMenuClick = true;
        setTopbarNotificationMenuActive(prevTopbarNotificationMenuActive => !prevTopbarNotificationMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const toggleSearch = () => {
        setSearchActive(prevSearchActive => !prevSearchActive);
        searchClick = true;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onRightMenuButtonClick = (event) => {
        hideOverlayMenu();
        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
    };

    const blockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        }
        else {
            document.body.className += ' blocked-scroll';
        }
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        }
        else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

   

    const isDesktop = () => {
        return window.innerWidth > 1200;
    };

    const containerClassName = classNames('layout-wrapper',
        {
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive,
            'p-ripple-disabled': true,
        },
    	'layout-sidebar-blue');

	const onMenuClick = () => {
		menuClick = true;
	};

	const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
        }
    };

	const onRootMenuitemClick = () => {
        setMenuActive(prevMenuActive => !prevMenuActive);
    };

    return (
        <div className={containerClassName} data-theme={'light'} onClick={onDocumentClick}>
		    <div className="layout-content-wrapper">
                <AppTopBar 
					routers={routers} 
					topbarNotificationMenuActive={topbarNotificationMenuActive} 
					topbarUserMenuActive={topbarUserMenuActive} 
					onMenuButtonClick={onMenuButtonClick} 
					onSearchClick={toggleSearch}
                    onTopbarNotification={onTopbarNotificationMenuButtonClick} 
					onTopbarUserMenu={onTopbarUserMenuButtonClick} 
					onRightMenuClick={onRightMenuButtonClick} 
					onRightMenuButtonClick={onRightMenuButtonClick}>	
				</AppTopBar>

                <div className="layout-content">
					<Outlet />
                </div>
            </div>
			
			<AppMenu 
				model={menu} 
				menuMode={menuMode} 
				active={menuActive} 
				mobileMenuActive={staticMenuMobileActive} 
				onMenuClick={onMenuClick} 
				onMenuitemClick={onMenuitemClick} 
				onRootMenuitemClick={onRootMenuitemClick}>
			</AppMenu>
            <div className="layout-mask modal-in"></div>
			
        </div>
    );
}

export default App;
